export default {
  install: (app, options) => {
    window.fwSettings = {
      widget_id:
        process.env.VUE_APP_ENVIRONMENT === 'production'
          ? 62000000983
          : 1060000000568
    }
    if (typeof window.FreshworksWidget !== 'function') {
      const n = function () {
        n.q.push(arguments)
      }
      n.q = []
      window.FreshworksWidget = n
    }
    const freshWorksScript = document.createElement('script')
    freshWorksScript.setAttribute(
      'src',
      process.env.VUE_APP_ENVIRONMENT === 'production'
        ? 'https://widget.freshworks.com/widgets/62000000983.js'
        : 'https://ind-widget.freshworks.com/widgets/1060000000568.js'
    )
    freshWorksScript.setAttribute('async', true)
    freshWorksScript.setAttribute('defer', true)
    document.head.appendChild(freshWorksScript)

    if (typeof window.FreshworksWidget !== 'undefined') {
      window.FreshworksWidget('hide', 'launcher')
    }
  }
}
